"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _config = require("./config");

var _depCheck = _interopRequireDefault(require("../../dep-check"));

var _lunaContainer = _interopRequireDefault(require("../luna-container"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LunaSectionHeader = _react["default"].forwardRef(function (props, ref) {
  (0, _depCheck["default"])([{
    condition: function condition(_ref) {
      var padding = _ref.padding;
      return padding;
    },
    message: 'LunaSectionHeader: Use of the padding prop will be deprecated. Please use the margin prop or wrap the component with a LunaContainer for spacing instead.',
    breakingVersion: 4
  }], _objectSpread({}, props));
  var children = props.children,
      className = props.className,
      divider = props.divider,
      margin = props.margin,
      padding = props.padding,
      onBlur = props.onBlur,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      onMouseDown = props.onMouseDown,
      onMouseLeave = props.onMouseLeave,
      onMouseUp = props.onMouseUp,
      onTouchEnd = props.onTouchEnd,
      onTouchMove = props.onTouchMove,
      onTouchStart = props.onTouchStart;

  var filteredChildren = _react["default"].Children.toArray(children).map(function (el) {
    return el.type.displayName;
  });

  if (filteredChildren.length > 2 || filteredChildren[0] !== 'LunaSectionHeaderTitle' || filteredChildren[1] && filteredChildren[1] !== 'LunaSectionHeaderUtility') {
    throw new Error('LunaSectionHeader: problem with children (either too many or incorrect type/order)');
  }

  var getClassList = function getClassList() {
    var _classnames;

    var base = _config.classes.base,
        resetMarginClass = _config.classes.resetMarginClass,
        resetPaddingClass = _config.classes.resetPaddingClass;
    return (0, _classnames2["default"])((_classnames = {}, _defineProperty(_classnames, base, true), _defineProperty(_classnames, resetMarginClass, margin ? Array.isArray(margin) ? margin[0] === _config.LunaSectionHeaderMargins.l0 : margin === _config.LunaSectionHeaderMargins.l0 : null), _defineProperty(_classnames, resetPaddingClass, padding ? Array.isArray(padding) ? padding[0] === _config.LunaSectionHeaderPaddings.l0 : padding === _config.LunaSectionHeaderPaddings.l0 : null), _classnames), className);
  };

  return _react["default"].createElement(_lunaContainer["default"], {
    className: getClassList(),
    divider: [divider],
    margin: margin,
    padding: [padding],
    onBlur: onBlur,
    onClick: onClick,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp,
    onMouseDown: onMouseDown,
    onMouseLeave: onMouseLeave,
    onMouseUp: onMouseUp,
    onTouchEnd: onTouchEnd,
    onTouchMove: onTouchMove,
    onTouchStart: onTouchStart,
    ref: ref
  }, children);
});

LunaSectionHeader.propTypes = {
  className: _propTypes["default"].string,
  divider: _propTypes["default"].oneOf(Object.values(_config.LunaSectionHeaderDividers)),
  margin: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].string]),
  padding: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].string]),
  type: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired,
  onBlur: _propTypes["default"].func,
  onClick: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  onKeyUp: _propTypes["default"].func,
  onMouseDown: _propTypes["default"].func,
  onMouseLeave: _propTypes["default"].func,
  onMouseUp: _propTypes["default"].func,
  onTouchEnd: _propTypes["default"].func,
  onTouchMove: _propTypes["default"].func,
  onTouchStart: _propTypes["default"].func
};
LunaSectionHeader.displayName = 'LunaSectionHeader';
var _default = LunaSectionHeader;
exports["default"] = _default;
